var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import BREAKPOINTS from '../../utils/breakpoints';
import { getSpacingClasses } from '../../utils/spacings';
import { collapseBaseStyles, collapseVariants } from '../../css/layout.css';
import { baseStyles, responsiveCollapsedColumnsVariants, responsiveRowGapVariants, rowGapVariants, } from './Columns.css';
const ColumnContext = React.createContext(null);
export const useColumnLayout = () => {
    const context = React.useContext(ColumnContext);
    if (!context) {
        throw new Error('A `<Column />` component can only be used inside a parent `<Columns />`.');
    }
    return context;
};
const defaultSpacing = {
    [BREAKPOINTS._0]: 8,
    [BREAKPOINTS._768]: 24,
};
export const Columns = React.forwardRef(function Columns(_a, ref) {
    var { as, children, className, collapseBelow, spacing = defaultSpacing } = _a, rest = __rest(_a, ["as", "children", "className", "collapseBelow", "spacing"]);
    const Component = as || 'div';
    const rowGapStyles = React.useMemo(() => getSpacingClasses(spacing, rowGapVariants, responsiveRowGapVariants), [spacing]);
    return (_jsx(ColumnContext.Provider, { value: { collapseBelow, spacing }, children: _jsx(Component, Object.assign({ className: cx(baseStyles, rowGapStyles, collapseBelow && [
                collapseBaseStyles,
                collapseVariants[collapseBelow],
                responsiveCollapsedColumnsVariants[collapseBelow],
            ], className) }, rest, { ref: ref, children: children })) }));
});
